import { Parser } from "@siteimprove/alfa-parser";
import { Function, Token, } from "../../syntax/index.js";
import { Value } from "../value.js";
const { map, either } = Parser;
/**
 * {@link https://drafts.csswg.org/css-values/#urls}
 *
 * @public
 */
export class URL extends Value {
    static of(url) {
        return new URL(url);
    }
    _url;
    constructor(url) {
        super("url", false);
        this._url = url;
    }
    get url() {
        return this._url;
    }
    resolve() {
        return this;
    }
    equals(value) {
        return value instanceof URL && value._url === this._url;
    }
    hash(hash) {
        hash.writeString(this._url);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            url: this._url,
        };
    }
    toString() {
        return `url(${this._url})`;
    }
}
/**
 * @public
 */
(function (URL) {
    function isURL(value) {
        return value instanceof URL;
    }
    URL.isURL = isURL;
    /**
     * {@link https://drafts.csswg.org/css-values/#url-value}
     */
    URL.parse = map(either(Token.parseURL(), map(Function.parse("url", Token.parseString()), ([_, url]) => url)), (url) => URL.of(url.value));
})(URL || (URL = {}));
//# sourceMappingURL=url.js.map